import { render } from "./list-user-doc-demande.vue?vue&type=template&id=1607e8ea"
import script from "./list-user-doc-demande.vue?vue&type=script&lang=js"
export * from "./list-user-doc-demande.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__